'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('img', {
    src: '//s3.amazonaws.com/cdn.hellofax.com/images/info/signature_modal@2x.png?c=889c43a',
    alt: 'Signature Modal',
    className: 'm-marketing-page--image-signature-modal'
});

module.exports = _react2['default'].createClass({
    displayName: 'Electronic Signature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'HelloSign\'s Guide To Electronic Signatures',
            subtitle: 'Jump in and try electronic signing for yourself! Click here to create your free HelloSign account.',
            buttonText: 'LET\'S DO IT!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'What is an electronic signature?'), _jsx('p', {}, void 0, 'According to the ', _jsx('a', {
            href: 'http://www.techlawjournal.com/cong106/digsig/Default.htm',
            target: '_blank'
        }, void 0, 'U.S. Federal ESIGN Act'), ' passed in 2000, an electronic signature is an "electronic sound, symbol, or process, attached to or logically associated with a contract or other record and executed or adopted by a person with the intent to sign the record."'), _jsx('p', {}, void 0, 'In layman\'s terms, an electronic signature, often referred to as an e-signature, is a person\'s electronic expression of his or her agreement to the terms of a particular document.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What are electronic signatures used for?'), _jsx('p', {}, void 0, 'Electronic signatures are used on every sort of document you can imagine. For instance, ', _jsx('a', {
            href: '/',
            target: '_blank'
        }, void 0, 'HelloSign'), ' users use electronic signatures to:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Esign NDAs, timesheets, and employee onboarding paperwork'), _jsx('li', {}, void 0, 'Esign sales contracts, invoices, and approve proposals'), _jsx('li', {}, void 0, 'Fill out and sign leases and other rental and housing agreements'), _jsx('li', {}, void 0, 'Electronically sign tax documents, bank forms, and insurance paperwork'), _jsx('li', {}, void 0, 'Fill out and sign permission slips, school forms, and release')), _jsx('h2', {
            className: headerClass
        }, void 0, 'How do electronic signatures work with HelloSign?'), _jsx('p', {}, void 0, 'There are ', _jsx('a', {
            href: 'http://blog.hellosign.com/signature-maker',
            target: '_blank'
        }, void 0, '4 ways to create an electronic signature'), ' using HelloSign.'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Draw your signature using your computer mouse or touchpad'), _jsx('li', {}, void 0, 'Take a photo of your signature using your smartphone and upload it to HelloSign'), _jsx('li', {}, void 0, 'Type your name and select any one of our fonts to give your typed signature an authentic touch'), _jsx('li', {}, void 0, 'Sign using your finger either on our mobile app for iOS and Android, or using our in-person signing feature on the iPad')), _jsx('p', {}, void 0, 'Once created, an electronic signature can be added to any document along with other annotations such as check marks or freeform text.'), _jsx('div', {
            className: 'text-center l-padding-t-60'
        }, void 0, _ref), _jsx('h2', {
            className: headerClass
        }, void 0, 'Are electronic signatures legal?'), _jsx('p', {}, void 0, 'Yes, ', _jsx('a', {
            href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
            target: '_blank'
        }, void 0, 'electronic signatures are valid and legal'), ' in the United States, Canada, the European Union, the UK, and many other areas of the world. View more about the legality ofelectronic signatures ', _jsx('a', {
            href: '/info/legal',
            target: '_blank'
        }, void 0, 'here'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What are the benefits of electronic signatures?'), _jsx('p', {}, void 0, 'There are many benefits to using an electronic signature. Using electronic signatures through HelloSign you can:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Get documents signed fast'), _jsx('li', {}, void 0, 'Sign documents from anywhere'), _jsx('li', {}, void 0, 'Collect ', _jsx('a', {
            href: 'http://blog.hellosign.com/are-esignatures-secure',
            target: '_blank'
        }, void 0, 'secure and legally binding signatures')), _jsx('li', {}, void 0, 'And ', _jsx('a', {
            href: '/info/benefits',
            target: '_blank'
        }, void 0, 'many more'))));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Ready to dive in and try electronic signing for yourself? Want to see more?',
            signupButtonText: 'SIGN UP FOR A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'OUR HAPPY USERS',
            embeddedTweetsHeaderText: 'SOCIAL LOVE'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/electronic-signature.jsx
 ** module id = 827
 ** module chunks = 0
 **/